import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgErrorOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7.948 2.129a.519.519 0 0 0-.057.05L2.18 7.892a.519.519 0 0 0-.051.057l-.002.042v8.02c0 .02 0 .034.002.042a.52.52 0 0 0 .05.057l5.712 5.711a.516.516 0 0 0 .057.051l.042.002h8.02c.02 0 .034 0 .042-.002a.517.517 0 0 0 .057-.05l5.711-5.712a.517.517 0 0 0 .051-.057l.002-.042V7.99a.357.357 0 0 0-.002-.042.516.516 0 0 0-.05-.057L16.108 2.18a.52.52 0 0 0-.057-.051.357.357 0 0 0-.042-.002H7.99a.357.357 0 0 0-.042.002Zm.008-.006-.001.001h.001Zm8.088 0 .001.001h-.001Zm5.833 5.833-.001-.001v.001Zm0 8.088-.001.001v-.001Zm-5.833 5.833.001-.001h-.001Zm-8.088 0-.001-.001h.001Zm-5.833-5.833.001.001v-.001Zm0-8.088.001-.001v.001ZM7.087.183C7.381.053 7.684 0 7.99 0h8.02c.306 0 .61.052.903.183.289.128.515.309.7.493l5.711 5.711c.184.185.365.411.493.7.13.294.183.597.183.903v8.02c0 .306-.052.61-.183.903a2.32 2.32 0 0 1-.493.7l-5.711 5.711a2.32 2.32 0 0 1-.7.493 2.2 2.2 0 0 1-.903.183H7.99c-.306 0-.61-.052-.903-.183a2.32 2.32 0 0 1-.7-.493L.676 17.613a2.32 2.32 0 0 1-.493-.7A2.193 2.193 0 0 1 0 16.01V7.99c0-.306.052-.61.183-.903a2.32 2.32 0 0 1 .493-.7L6.387.676a2.32 2.32 0 0 1 .7-.493ZM12 6.076c.587 0 1.063.476 1.063 1.063V12a1.063 1.063 0 0 1-2.126 0V7.14c0-.588.476-1.064 1.063-1.064ZM10.937 16.86c0-.588.476-1.064 1.063-1.064h.012a1.063 1.063 0 0 1 0 2.127H12a1.063 1.063 0 0 1-1.063-1.063Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgErrorOutline);
export default ForwardRef;
